import React from "react";
import Sidebartab from "../../components/global/Sidebartab";
import Topbar from "../../components/global/Topbar";
import { ProSidebarProvider } from "react-pro-sidebar";


const adminDashboard = ( props ) => {
  const {Children} =props;
  return (
    <>
    <Topbar /> 

    <div className="app" > 
     <ProSidebarProvider>
     <Sidebartab />
     </ProSidebarProvider>
     
    <div className="content" > 
     <Children />
     </div>
    </div>
    </>
   
  );
};

export default adminDashboard;
